<template>
    <span :style="{color: color}" class="icon" aria-hidden="true"></span>
</template>
<script>
let cache = new Map();
export default {
  props: {
    color: { type: String, required: false },
    src: { type: String, required: true }
  },
  async mounted() {
    if (!cache.has(this.src)) {
      try {
        cache.set(this.src, fetch(this.src).then(r => r.text()));
      } catch (e) {
        cache.delete(this.src);
      }
    }
    if (cache.has(this.src)) {
      this.$el.innerHTML = await cache.get(this.src);
    }
  }
};
</script>

<style lang="scss">

.icon {
  display: inline-block;
  width: 100%;
  fill: currentColor;

  svg {
    float:left;
  }

}

</style>


// WEBPACK FOOTER //
// Icon.vue?f05e65a6